export default function transformRes(res: string) {
  const jsonStartingChars = ["{", "["];
  return jsonStartingChars.includes(res.charAt(0)) ? JSON.parse(res) : res;
}
